export default {
  appId: 1010,
  timeout: 60000,
  oem_key_sit: "SIT_4VjZdg19laDoIrut",
  oem_key_prod: "PROD_ZvpXaQnlibUri3ZV",
  eom_secret: "meicloud",
};
